// Texty mobilného ovládania výpisu — slovenské dvojča mobileFilter.js.
export default {
  filter: 'Filtrovať',
  filterTitle: 'Filtrácia',
  filterClose: 'Zavrieť filter',
  sortOpen: 'Zoradiť',
  sortPrefix: 'Zoradiť: ',
  sortTitle: 'Zoradiť podľa',
  clear: 'Vymazať',
  clearAll: 'Vymazať všetko',
  show: (n, word) => 'Zobraziť ' + n + ' ' + word,
  showAll: 'Zobraziť produkty',
};
